import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Textfield } from 'react-mdl'
import { Stepper, Step, StepActions, StepContent } from 'react-mdl-stepper';
import 'react-mdl-stepper/stepper.css';

const jsonData = require('./ChannelConfigSteps');

//used to get a nested value, for example channel.webhook.url
//http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key
Object.resolve = function(path, obj) {
  return path.split('.').reduce(function(prev, curr) {
                                return prev ? prev[curr] : undefined
                                }, obj || self)
}

export class ChannelConfigStepper extends Component {

  static propTypes = {
    channelType: PropTypes.string.isRequired,
    onBeforeNextStep: PropTypes.func.isRequired,
    renderStep: PropTypes.func,
    channel: PropTypes.object,
  }

  constructor(props,context) {
    super(props,context);

    this.state = {
      title: this.props.channel ? this.props.channel.title : '',
      params: this.props.channel ? {...this.props.channel.params} : {},
      json: jsonData[this.props.channelType]
    }

    this.handleParamTextFieldChange = this.handleParamTextFieldChange.bind(this);
    this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.onNext = this.onNext.bind(this);
    //this.renderStepperItem = this.renderStepperItem.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.channel !== nextProps.channel) {
      this.setState({
          title: nextProps.channel.title,
          params: nextProps.channel.params
      })
    }
  }

  handleParamTextFieldChange(event) {
    const params = {...this.state.params}
    params[event.target.name] = event.target.value;
    this.setState({params: params});
  }

  handleTextFieldChange(event) {
    const state = {...this.state}
    state[event.target.name] = event.target.value;
    this.setState(state);
  }

  isLastStep() {
    return this.stepper.state.activeStep === this.state.json.steps.length
  }

  activeStepConfig() {
    const step = this.stepper.state.activeStep
    return this.state.json.steps[step-1]
  }

  nextStep() {
    const stepConfig = this.state.json.steps[this.stepper.state.activeStep-1]

    const { required, action, value } = stepConfig

    if (required) {
      if (action === 'edit-param') {
        if (!this.state.params[value] || this.state.params[value] === '') {
          return
        }
      }
      else if (action === 'edit-title') {
        if (!this.state[value] || this.state[value] === '') {
          return
        }
      }
    }
    this.props.onBeforeNextStep()
  }

  onNext() {

  }

  previousStep() {
    const step = this.stepper.state.activeStep
    this.stepper.setStep(step - 1)
  }


  renderStepperItem(e, index, lastStep) {
    const {title, image, action, label, value, required, save, hideBack} = e

    const disabled = this.props.channel ? save !== 'edit' : false

    const text = this.props.channel ? (e.view_text !== undefined ? e.view_text : e.text) : e.text

    let showProp = null
    if (action === 'show-prop' && this.props.channel) {
      showProp = Object.resolve(value, this.props.channel)
    }

    return (
      <Step key={index} title={title} editable={this.props.channel !== null} onNext={this.onNext}>
        <StepContent>
          <p dangerouslySetInnerHTML={{__html: text}}></p>
          <div>{this.props.renderStep && this.props.renderStep(e, index+1)}</div>
          { image !== undefined ? <img alt={image} src={'/images/channels/'+image} style={{maxWidth:'100%', maxHeight:'100%'}}/> : '' }
          { action === 'edit-param' ? <Textfield name={value} onChange={this.handleParamTextFieldChange} label={label ? label : value} style={{width: '450px'}} value={this.state.params[value] !== undefined ? this.state.params[value] : ''} floatingLabel required={required} disabled={disabled} /> : '' }
          { action === 'edit-title' ? <Textfield name={value} onChange={this.handleTextFieldChange} label={value} style={{width: '450px'}} value={this.state[value] !== undefined ? this.state[value] : ''} floatingLabel required={required} disabled={disabled} /> : '' }
          { showProp ? showProp : ''}
        </StepContent>
        <StepActions>
           {index === 0 || hideBack !== undefined ? '' : <Button onClick={this.previousStep}>Back</Button>}&nbsp;
           <Button colored raised onClick={this.nextStep}>{ lastStep ? 'Done' : (save && !disabled ? 'Save' : 'Continue')}</Button>
        </StepActions>
      </Step>
    )
  }


  render() {
    const { json } = this.state

    return (
      <div>
        <p>{json.description}</p>
        <Stepper ref={(input) => this.stepper = input}>
        {
          json.steps.map( (e, index) => (
            this.renderStepperItem(e, index, index === json.steps.length - 1)
          ))
        }
        </Stepper>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/ChannelConfigStepper.js